import { SUCCESS } from '../../../../../constants/action-postfix'
import { COMMISSION_GET_REQUEST, COMMISSION_UPDATE_REQUEST } from '../../commissionActionTypes'

const initialState = null

export const commissionCurrentDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${COMMISSION_GET_REQUEST}${SUCCESS}`:
    case `${COMMISSION_UPDATE_REQUEST}${SUCCESS}`:
      return action.payload

    default:
      return state
  }
}
